import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=08d1b5ea&scoped=true&"
import script from "./cancelOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cancelOrder.vue?vue&type=style&index=1&id=08d1b5ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1b5ea",
  null
  
)

export default component.exports